import React, { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'

import { ISimpleLabelValueProps } from './SimpleLabelValues.types'
import { LabelCard, Title, Value } from './styles'

const LabelValue: FunctionComponent<ISimpleLabelValueProps> = ({
  title,
  value,
}) => {
  return (
    <LabelCard>
      <Grid container>
        <Title>{title}</Title>
        <Grid container>
          <Grid>
            <Value>{value}</Value>
          </Grid>
        </Grid>
      </Grid>
    </LabelCard>
  )
}

export default LabelValue
